// extracted by mini-css-extract-plugin
module.exports = {"container":"Asct_container__3uraF","tar":"Asct_tar__2rNOS","note":"Asct_note__3mxAR"};